<template>
  <div class="leading-relaxed space-y-10">
    <section>
      <h2 class="text-2xl font-semibold text-primary mb-3">
        1. Պայմանների ընդունում
      </h2>
      <p>
        Մուտք գործելով կամ օգտագործելով MEDIUM.am-ը՝ դուք համաձայնում եք
        ենթարկվել սույն Օգտագործման պայմաններին: Եթե համաձայն չեք այս պայմանների
        հետ, խնդրում ենք չօգտվել մեր հարթակից:
      </p>
    </section>

    <section>
      <h2 class="text-2xl font-semibold text-primary mb-3">2. Ծառայությունը</h2>
      <p>
        MEDIUM.am-ը համայնքային հարթակ է, որը նախատեսված է արվեստագետներին և
        արվեստասերներին միմյանց հետ կապելու համար: Մենք տրամադրում ենք գործիքներ
        պրոֆիլ ստեղծելու, որոնման և ցանցային փոխգործակցության համար:
      </p>
      <p class="mt-2">
        <strong>Կապող օղակ.</strong> MEDIUM.am-ը հանդես է գալիս բացառապես որպես
        միջնորդ: Մենք չենք մասնակցում և կողմ չենք հանդիսանում օգտատերերի միջև
        կնքված որևէ համաձայնագրի, վաճառքի կամ գործարքի:
      </p>
    </section>

    <section>
      <h2 class="text-2xl font-semibold text-primary mb-3">
        3. Օգտատիրոջ հաշիվներ և անվտանգություն
      </h2>
      <p>
        Որոշակի գործառույթներից օգտվելու համար դուք պետք է գրանցեք հաշիվ
        էլեկտրոնային փոստի կամ Google Sign-In-ի միջոցով: Դուք պատասխանատու եք՝
      </p>
      <ul class="list-disc list-inside mt-2 space-y-1 ml-4">
        <li>
          Ճշգրիտ և ամբողջական տեղեկատվություն տրամադրելու համար (Անուն, Էլ. փոստ
          և այլն):
        </li>
        <li>Ձեր հաշվի անվտանգության պահպանման համար:</li>
        <li>Ձեր հաշվի ներքո տեղի ունեցող բոլոր գործողությունների համար:</li>
      </ul>
    </section>

    <section>
      <h2 class="text-2xl font-semibold text-primary mb-3">
        4. Վճարումներ և երրորդ կողմի գործարքներ
      </h2>
      <p>
        MEDIUM.am-ը ներկայումս վճարումներ չի իրականացնում: Ցանկացած ֆինանսական
        գործարք, միջնորդավճար կամ արվեստի գործի գնում տեղի է ունենում բացառապես
        արվեստագետի և արվեստասերի միջև՝ իրենց կողմից ընտրված երրորդ կողմի
        մեթոդներով:
      </p>
      <p class="mt-2 font-medium text-red-600">
        Մենք պատասխանատվություն չենք կրում վճարային վեճերի, վերադարձի կամ
        ձախողված առաքումների համար, որոնք առաջացել են հարթակում օգտատերերի միջև
        փոխգործակցության արդյունքում:
      </p>
    </section>

    <section>
      <h2 class="text-2xl font-semibold text-primary mb-3">
        5. Օգտատիրոջ բովանդակությունը և վարքագիծը
      </h2>
      <p>
        Օգտատերերը կրում են անձնական պատասխանատվություն իրենց կողմից հրապարակված
        բովանդակության համար (նկարներ, կենսագրություն, տեքստ): MEDIUM.am-ը
        մարդկային ստեղծագործության տարածք է, հետևաբար՝
      </p>
      <ul class="list-disc list-inside mt-2 space-y-1 ml-4 font-medium">
        <li class="text-red-600">
          Արհեստական բանականության (AI) կողմից ստեղծված բովանդակությունը խստիվ
          արգելվում է:
        </li>
        <li>
          Բովանդակությունը պետք է ուղղակիորեն կապված լինի արվեստի և արվեստի
          համայնքի հետ:
        </li>
        <li>
          Բովանդակությունը չպետք է խախտի մտավոր սեփականության իրավունքները:
        </li>
        <li>Ապօրինի, վիրավորական կամ վնասակար նյութերն արգելված են:</li>
      </ul>
      <p class="mt-4 bg-gray-50 p-3 border-l-4 border-red-500 italic">
        <strong>Զրոյական հանդուրժողականության քաղաքականություն.</strong> Արվեստի
        հետ չառնչվող կամ AI-ով ստեղծված ցանկացած նյութ կհեռացվի հարթակից մշտապես
        և առանց նախնական ծանուցման:
      </p>
    </section>
    <section>
      <h2 class="text-2xl font-semibold text-primary mb-3">
        6. Ներմուծում Instagram-ից
      </h2>
      <p>
        Instagram-ից ներմուծման գործառույթն օգտագործելիս դուք պետք է միացնեք
        Instagram-ի այն հաշիվը, որի սեփականատերն եք կամ որը կառավարելու
        լիազորություն ունեք։ Դուք կարող եք ներմուծել միայն այն բովանդակությունը,
        որն օգտագործելու և հրապարակելու իրավունքն ունեք։
      </p>
      <p class="mt-2">
        MEDIUM.am-ն իրեն իրավունք է վերապահում հեռացնել ներմուծված այն
        բովանդակությունը, որը, ըստ երևույթին, ձեռք է բերվել առանց թույլտվության
        կամ խախտում է սույն Օգտագործման պայմանները։
      </p>
    </section>
    <section>
      <h2 class="text-2xl font-semibold text-primary mb-3">
        7. Պատասխանատվության սահմանափակում
      </h2>
      <p>
        MEDIUM.am-ը տրամադրվում է «ինչպես կա» հիմունքներով՝ առանց որևէ տեսակի
        երաշխիքների: Մենք պատասխանատվություն չենք կրում որևէ անուղղակի կամ
        պատահական վնասի համար, որն առաջացել է հարթակի օգտագործման կամ այլ
        օգտատերերի հետ ձեր շփումների հետևանքով:
      </p>
    </section>

    <section>
      <h2 class="text-2xl font-semibold text-primary mb-3">
        8. Հաշվի կասեցում
      </h2>
      <p>
        Մենք իրավունք ենք վերապահում կասեցնել կամ ջնջել այն հաշիվները, որոնք
        խախտում են սույն պայմանները կամ վնասում են համայնքի հեղինակությանը:
      </p>
    </section>

    <section>
      <h2 class="text-2xl font-semibold text-primary mb-3">8. Հետադարձ կապ</h2>
      <p>Այս պայմանների վերաբերյալ հարցերը պետք է ուղարկվեն հետևյալ հասցեին՝</p>
      <p class="text-primary font-bold mt-2">contact@medium.am</p>
    </section>

    <div class="text-center mt-10 text-sm italic">
      <p>Շնորհակալություն MEDIUM.am արվեստի համայնքի մասնիկը լինելու համար:</p>
    </div>
  </div>
</template>
